"use client";

import { useRef, useState } from "react";
import { cn } from "~/utils/cn";
import SearchInput from "./SearchInput";
import { type MenuFields_Fields } from "~/__generated__/graphql";
import HoverMenu from "./HoverMenu";

export default function Navigation({
  menuLinks,
}: {
  menuLinks: MenuFields_Fields["menuLinks"];
}) {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isSearchOpen, setSearchOpen] = useState(false);

  const inputRefMenu = useRef<HTMLInputElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  function handleClick() {
    setSearchOpen(!isSearchOpen);

    if (!isMenuOpen && inputRefMenu.current) {
      // We have to timeout, otherwise it doesnt correctly focus (even with 0s
      // timeout).
      setTimeout(() => {
        inputRefMenu.current?.focus();
      }, 0);
      return;
    }

    if (isMenuOpen && inputRef.current) {
      return inputRef.current?.focus();
    }
  }

  //   function handleClickOutside(e: MouseEvent) {
  //     if (!contentContainer?.current) return;

  //     detectOutsideClick(e, contentContainer, () => setMenuOpen(false));
  //   }

  return (
    <div className="flex h-full items-center gap-3.5">
      <ul
        className={cn(
          "hidden h-full items-center gap-3.5",
          isSearchOpen ? "" : " lg:flex",
        )}
      >
        {menuLinks?.map((menuLink) => (
          <HoverMenu
            key={menuLink?.title ?? ""}
            title={menuLink?.title ?? ""}
            url={menuLink?.link?.url ?? ""}
            subLinks={
              menuLink?.subMenuLinks?.map((subMenuLink) => ({
                title: subMenuLink?.title ?? "",
                url: subMenuLink?.link?.url ?? "",
              })) ?? []
            }
          />
        ))}
      </ul>
      <button
        onClick={handleClick}
        className={cn([
          "h-10 w-10 p-2 transition-opacity",
          isSearchOpen ? "opacity-0" : "opacity-1 delay-500",
        ])}
        aria-label="Search NewCold"
      >
        <span className="material-icons-round text-white">search</span>
      </button>

      {!isMenuOpen && (
        <SearchInput
          ref={inputRefMenu}
          setSearchOpen={setSearchOpen}
          isSearchOpen={isSearchOpen}
        />
      )}
    </div>
  );
}
